const html = require("./html/pickupSchedulingView.html");
import {setElementsFromScope, swapClasses, setDisabled, setCheckboxState, insertValAndManageFocus, insertTextAndClean, show, hide, handleDisplayForV2, allElements} from "../../../utilities/selectorHelpers";
import {unbindAll, extractElements} from "../../../utilities/viewHelpers";
import _ from "underscore";
import $ from "jquery";
import AsnStore from "../../../stores/AsnStore";
import timePicker from "../../../components/timePicker";

const elementsMap = {
  pickupDateInput: ".pickup-date-input",
  pickupDateMessage: ".pickup-date-message",
  insidePickupCheckbox: ".inside-pickup-checkbox",
  liftGatePickupCheckbox: ".lift-gate-pickup-checkbox",
  limitedAccessCheckbox: ".limited-access-checkbox",
  lumperPickupCheckbox: ".lumper-pickup-checkbox",
  driverLoadCheckbox: ".driver-load-checkbox",

  pickupTimeRangeMessage: ".shipping-tab-pickup-time-range-error-message",

  insidePickupMessageOuter: ".inside-pickup-message-outer",
  liftGatePickupMessageOuter: ".lift-gate-pickup-message-outer",
  limitedAccessMessageOuter: ".limited-access-message-outer",
  lumperPickupMessageOuter: ".lumper-pickup-message-outer",
  driverLoadMessageOuter: ".driver-load-message-outer",

  timePickerFrom: ".time-picker-from",
  timePickerTo: ".time-picker-to",

//   pickupTimeFromHoursInput: ".pickup-time-from-hours-input",
//   pickupTimeFromMinutesInput: ".pickup-time-from-minutes-input",
//   pickupTimeFromPeriodInput: ".pickup-time-from-period-input",

//   pickupTimeToHoursInput: ".pickup-time-to-hours-input",
//   pickupTimeToMinutesInput: ".pickup-time-to-minutes-input",
//   pickupTimeToPeriodInput: ".pickup-time-to-period-input", 
}

const PICKUP_DATE_MESSAGE_STUB = " pick-ups will incur additional expense in your shipping quote."
 
export default function PickupSchedulingView(_unused, {
  getAsn,
  onAsnFieldChange,
  onAsnFieldsChange,
  isPallet,
  readOnly
}){
  const self = this;
  self._element = $();
  const els = {};
  let asnDetailRowViews = [];
  let timePickerFrom, timePickerTo;

  self.init = function(){
    render();
  }

  function setElements(){
    setElementsFromScope(els, elementsMap, self._element);
  }

  function setWidgets(){
    instantiatePickupDatePicker();
  }

  function instantiatePickupDatePicker(){
    const date = new Date();
    date.setDate(date.getDate() + 1);
    els.pickupDateInput.datepicker({ 
      startDate: date,
      todayBtn: "linked",
      keyboardNavigation: false,
      autoclose: true
    });

    const timePickerOptions = {disableAll: readOnly};

    timePickerFrom = timePicker(els.timePickerFrom, timePickerOptions);
    timePickerTo = timePicker(els.timePickerTo, timePickerOptions);
  }

  self.getElement = function(){
    return self._element;
  }

  function update(){
    updateSelf();
  }

  function updateSelf(){
    updateVals();
    updateMessages();


  }

  function updateTimeFor(timePicker, obj, keyExt){
    timePicker.setTimeFromMilitary(obj[`pickupTime${keyExt}`]);
  }

  function updateVals(){
    // update all inputs
    const asn = getAsn();
    insertValAndManageFocus(els.pickupDateInput, asn.pickupDate);

    updateTimeFor(timePickerFrom, asn, "From");
    updateTimeFor(timePickerTo, asn, "To");

    setCheckboxState(els.insidePickupCheckbox, asn.insidePickup);
    setCheckboxState(els.liftGatePickupCheckbox, asn.liftGatePickup);
    setCheckboxState(els.limitedAccessCheckbox, asn.limitedAccess);
    setCheckboxState(els.lumperPickupCheckbox, asn.lumperPickup);
    setCheckboxState(els.driverLoadCheckbox, asn.driverLoad);
  }

  function updateMessages(){
    const asn = getAsn();
    // one pickup date message at a time
    let pickupMessage = getHolidayPickupDateMessage(asn) || getWeekendPickupDateMessage(asn);
    insertTextAndClean(els.pickupDateMessage, pickupMessage);
    handleDisplayForV2(els.pickupTimeRangeMessage, !isPickupTimeRangeValid(asn));
    handleDisplayForV2(els.insidePickupMessageOuter, asn.insidePickup);
    handleDisplayForV2(els.liftGatePickupMessageOuter, asn.liftGatePickup);
    handleDisplayForV2(els.limitedAccessMessageOuter, asn.limitedAccess);
    handleDisplayForV2(els.lumperPickupMessageOuter, asn.lumperPickup);
    handleDisplayForV2(els.driverLoadMessageOuter, asn.driverLoad);
  }

  function isPickupTimeRangeValid(asn){
    return AsnStore.isPickupTimeRangeValid(asn);
  }

  function getHolidayPickupDateMessage(asn){
    const isHoliday = !!AsnStore.getPickupDateHoliday(asn);
    let message = "";
    if(isHoliday){
      message = "Holiday" + PICKUP_DATE_MESSAGE_STUB;
    }
    return message;
  }

  function getWeekendPickupDateMessage(asn){
    const isWeekend = !!AsnStore.getPickupDateWeekend(asn);
    let message = "";
    if(isWeekend){
      message = "Weekend" + PICKUP_DATE_MESSAGE_STUB;
    }
    return message;
  }


  function bindStores(){
    AsnStore.bindListener("asns:shipping_method_changed", updateSelf);
    AsnStore.bindListener("asns:change", updateSelf);
  }

  self.unbindListeners = function(){
    AsnStore.unbindListener("asns:shipping_method_changed", updateSelf);
    AsnStore.unbindListener("asns:change", updateSelf);
    allElements(els).off();
  }

  function bindElements(){
    els.pickupDateInput.on("input change", handleAsnFieldChange("pickupDate"));
    els.insidePickupCheckbox.on("click", handleAsnFieldCheckboxChange("insidePickup"));
    els.liftGatePickupCheckbox.on("click", handleAsnFieldCheckboxChange("liftGatePickup"));
    els.limitedAccessCheckbox.on("click", handleAsnFieldCheckboxChange("limitedAccess"));
    els.lumperPickupCheckbox.on("click", handleAsnFieldCheckboxChange("lumperPickup"));
    els.driverLoadCheckbox.on("click", handleAsnFieldCheckboxChange("driverLoad"));


    els.timePickerFrom.on("change", handleTimeChangeFor(timePickerFrom, "pickupTimeFrom"));
    els.timePickerTo.on("change", handleTimeChangeFor(timePickerTo, "pickupTimeTo"));

  }


  function handleTimeChangeFor(tPicker, key){
    return function(e){
      const time = tPicker.getMilitaryTime();
      onAsnFieldChange(key, time);
    }
  }


  function handleAsnFieldChange(key){
    return function(e){
      onAsnFieldChange(key, $(this).val());
    }
  }

  function handleAsnFieldsChange(key){
    return function(e){
      onAsnFieldsChange(key, $(this).val());
    }
  }


  function handleAsnFieldCheckboxChange(key){
    return function(e){
      onAsnFieldChange(key, !!$(this).is(":checked"));
    }
  }

  function handleReadOnly(){
    if(readOnly){
      setDisabled([
        els.pickupDateInput,
        els.insidePickupCheckbox,
        els.liftGatePickupCheckbox,
        els.limitedAccessCheckbox,
        els.lumperPickupCheckbox,
        els.driverLoadCheckbox
      ])
    }
  }


  function render(){
    self._element = $(html);
    setElements();
    setWidgets();
    update();
    handleReadOnly();
    bindElements();
    bindStores();
  }

}


// WEBPACK FOOTER //
// ./src/pages/asns/ShippingTab/PickupSchedulingView.js